import { isMobileDevice } from 'shared/lib/isMobileDevice'

export const checkAccessLandingMobilePage = () => {
  const exist = window.localStorage.getItem('landing_mobile_exist')

  return isMobileDevice() && !exist
}
